export const approvalStatusList = [
  { label: '审核中', value: 0 },
  { label: '审核通过', value: 1, color: '#188422' },
  { label: '审核未通过', value: 2, color: '#d9011c' }
]

export const searchList = [
  { prop: 'approvalStatusList', type: 'select', attrs: { placeholder: '审核状态', width: '140px' }, items: approvalStatusList },
  {
    prop: 'queryTimeType', type: 'select', attrs: { width: '140px' }, items: [
      { label: '提交审核时间', value: 0 },
      { label: '审核完成时间', value: 1 },
    ]
  },
  {
    prop: 'timeShortcut', type: 'select', attrs: { width: '140px', clearable: false }, items: [
      { label: '今天', value: 0 },
      { label: '近7天', value: 6 },
      { label: '近1个月', value: 30 },
      { label: '近3个月', value: 90 },
      { label: '自定义', value: -1 },
    ]
  },
]
export const colList = (unvisibleList = []) => {
  const list = [
    { prop: 'created', attrs: { label: '提交审核时间' } },
    { prop: 'approvalDate', attrs: { label: '审核完成时间' } },
    { prop: 'approvalStatus', attrs: { label: '审核状态' } , slot: true},
    { prop: 'approvalAfterPrice', attrs: { label: '修改后供货价', align: 'right' } , slot: true },
    { prop: 'approvalInfo', attrs: { label: '审核备注', 'show-overflow-tooltip': true } }
  ]
  return list.filter(item => !unvisibleList.includes(item.prop));
}